<template>
   <div v-if="status" class="Radius border border-primary shadow rounded bg-white p-2 small mb-3 text-primary " >
       <b-media tag="li">
           <template v-slot:aside>
               <b-avatar variant="primary" badge-variant="danger" size="3rem"  :src="require('../assets/ui/annie.png')">
                   <template v-slot:badge><b-icon icon="star-fill"></b-icon>
                   </template>
               </b-avatar>
           </template>
           <h6 class="mt-0 mb-1">大師秘訣：</h6>
           <p class="mb-0 text-dark" style="font-size: 1rem">
               {{ tipswords }}
               <b-button v-if="videostatus" pill variant="primary" size="sm" class="shadow-lg"><b-icon icon="play-fill"  style="color: #fff"  ></b-icon></b-button>
           </p>
       </b-media>

   </div>
</template>
<style >
    .Radius {
        /*height: 22vw;*/
        /*max-height: 130px;*/
        /*max-width: 130px;*/
        /*width: 22vw;*/
        /*!*background-color: #be9167;*!*/
        /*border-color: #be9167 !important;*/
        /*border: 2px solid rgba(0, 0, 0, 0.125);*/
        border-radius: 2rem !important;
    }
</style>

<script>

export default {
  name: 'TipsAlert',
  props: {
    status:Boolean,
    videostatus:Boolean,
    videosrc:String,
    tipswords:String,
  },
  computed: {

  },
  data () {
    return {


    }
  },
  methods: {


  }
}
</script>
